// extracted by mini-css-extract-plugin
export default {"FormLayout":"changePassword_FormLayout__AW63c","Form":"changePassword_Form__XhCjS","Buttons":"changePassword_Buttons__tcZcX"};